import { render, staticRenderFns } from "./BalaAssignadaMagatzemsList.vue?vue&type=template&id=9ad39d9e&scoped=true"
import script from "./BalaAssignadaMagatzemsList.vue?vue&type=script&lang=js"
export * from "./BalaAssignadaMagatzemsList.vue?vue&type=script&lang=js"
import style0 from "./BalaAssignadaMagatzemsList.vue?vue&type=style&index=0&id=9ad39d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad39d9e",
  null
  
)

export default component.exports